import {useTranslation} from "react-i18next";
import "./Parts.css"
import {NavLink} from "react-router-dom";
import useAnimation from "../../utils/hooks/animate";
import {useEffect} from "react";

export const Parts = () => {
    const {t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("parts")});
    }, [t]);

    return (
        <main className="pt-2">
            <section>
                <p className="text-center animated">{t('parts.1.1')}</p>
            </section>
            <section>
                <p className="text-center animated">{t('parts.2.1')}</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.2.2.1')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.2.2.2')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.2.2.3')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.2.2.4')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.2.2.5')}</p></li>
                </ul>
                <p className="text-center animated">
                    {t('parts.2.3')}<span> </span>
                    <NavLink
                        // className="d-flex justify-content-center"
                        to={"/ufa"}>
                        {t("ufa")}
                    </NavLink>
                </p>
            </section>
            <section>
                <p className="text-center header-main animated">{t('parts.3.1')}</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light">
                        <p className="animated">{t('parts.3.2.1')}</p>
                        <p className="animated">{t('parts.3.2.2')}</p>
                        <p className="animated">{t('parts.3.2.3')}</p>
                    </li>
                    <li className="list-group-item bg-light">
                        <p className="animated">{t('parts.3.2.4')}</p>
                        <p className="animated">{t('parts.3.2.5')}</p>
                        <p className="animated">{t('parts.3.2.6')}</p>
                        <p className="animated">{t('parts.3.2.7')}</p>
                    </li>
                    <li className="list-group-item bg-light">
                        <p className="animated">{t('parts.3.2.8')}</p>
                        <p className="animated">{t('parts.3.2.9')}</p>
                    </li>
                </ul>
            </section>
            <section>
                <p className="text-center header-main animated">{t('parts.4.1')}</p>
                <ul className="list-group">
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.4.2.1')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.4.2.2')}</p></li>
                    <li className="list-group-item bg-light"><p className="animated">{t('parts.4.2.3')}</p></li>
                </ul>
            </section>
            {/*<section>*/}
            {/*    <p className="text-center header-main animated">{t('parts.p.2')}</p>*/}
            {/*    <ul className="list-group">*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.1')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.2')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.3')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.4')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.5')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.6')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.7')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.8')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.9')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.10')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.11')}</p></li>*/}
            {/*        <li className="list-group-item bg-light"><p className="animated">{t('parts.p.2.12')}</p></li>*/}
            {/*    </ul>*/}
            {/*</section>*/}
        </main>
    );
};